import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';

export default function BreederProfileReviewsSkeleton({
  className,
  reviewsPerPage
}) {
  const numOfReviews = reviewsPerPage || 6;

  return (
    <div
      className={classnames(
        'BreederProfileReviewsSkeleton container-xxl',
        className
      )}
    >
      <div className="grid gap-8 mb10">
        <SkeletonBlock className="font-20 lh-title" height="1em" width="10em" />
        <SkeletonBlock className="font-16" height="1em" width="100%" />
        <SkeletonBlock className="font-16" height="1em" width="80%" />
      </div>
      <ul>
        {makeSequence(numOfReviews).map(index => (
          <li key={index}>
            <div
              className={classnames('OwnerStorySkeleton', {
                'pb6 pb12-md': index !== numOfReviews - 1,
                'pt6 pt12-md bt b--default': index
              })}
            >
              <div className="flex items-center gap-12 mb4">
                <SkeletonBlock className="br-100" height="48px" width="48px" />
                <div className="flex-auto lh-copy">
                  <SkeletonBlock className="font-14" height="1em" width="8em" />
                  <SkeletonBlock
                    className="font-14 mt1"
                    height="1em"
                    width="16em"
                  />
                </div>
              </div>
              <div className="nh6 mb4">
                <div className="flex flex-nowrap gap-8 pl6">
                  <SkeletonBlock className="br3" width="268px" height="268px" />
                  <SkeletonBlock className="br3 flex-auto" height="268px" />
                </div>
              </div>
              <div className="flex flex-column gap-2">
                <SkeletonBlock className="font-14" height="1em" width="100%" />
                <SkeletonBlock className="font-14" height="1em" width="100%" />
                <SkeletonBlock className="font-14" height="1em" width="100%" />
                <SkeletonBlock className="font-14" height="1em" width="60%" />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

BreederProfileReviewsSkeleton.propTypes = {
  className: PropTypes.string,
  reviewsPerPage: PropTypes.number
};

BreederProfileReviewsSkeleton.defaultProps = {
  className: 'pv8',
  reviewsPerPage: null
};
